<template>
  <div class="order-info">
    <div class="table-wrapper" v-min-height>
      <div class="btn-all">
        <el-date-picker
          @change="filterMonth"
          class="select"
          v-model="month"
          type="month"
          format="yyyy年-MM月"
          value-format="yyyy-MM"
          placeholder="按月"
        />
        <el-button
          class="export fff-color"
          round
          v-permission:export="$route.meta.permission"
          >导出
        </el-button>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          border
          :height="500"
          :header-cell-style="{
            height: '2.5rem',
            color: '#333',
            border: 'none'
          }"
          :cell-style="{
            color: '#606060'
          }"
          style="margin-bottom: 4rem;"
          class="no-hover no-pad__bor"
        >
          <el-table-column
            fixed
            lable="商品标题"
            width="400"
            align="center"
            class-name="visible"
          >
            <template slot-scope="scope">
              <span class="top-bg" style="padding-left: 2rem"
                >订单号：{{ scope.row.paySn }}</span
              >
              <div class="order-details">
                <div
                  :class="
                    scope.row.goodsList.length > 1 ? 'box bor-bottom' : 'box'
                  "
                  v-for="(item, index) in scope.row.goodsList"
                  :key="index"
                >
                  <el-image :src="item.imgUrl" class="goods-img">
                    <div slot="error" class="image-slot">
                      <i class="iconfont icon-tupian" />
                    </div>
                  </el-image>
                  <div class="caption">
                    <p class="ellipses">
                      <el-tooltip
                        effect="light"
                        placement="bottom-start"
                        :content="item.cnName"
                      >
                        <span class="goods-name"> {{ item.cnName }}</span>
                      </el-tooltip>
                    </p>
                    <p class="ellipses">
                      <el-tooltip
                        effect="light"
                        placement="bottom-start"
                        :content="item.enName"
                      >
                        <span class="goods-name"> {{ item.enName }}</span>
                      </el-tooltip>
                    </p>
                    <p class="ellipses">
                      <el-tooltip
                        effect="light"
                        placement="bottom-start"
                        :content="item.sku"
                      >
                        <span class="goods-name">SKU编码：{{ item.sku }}</span>
                      </el-tooltip>
                    </p>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单价（元）" width="auto" align="center">
            <template slot-scope="scope">
              <span class="top-bg" />
              <div class="order-details">
                <div
                  :class="
                    scope.row.goodsList.length > 1
                      ? 'set-height bor-bottom'
                      : 'box'
                  "
                  v-for="(item, index) in scope.row.goodsList"
                  :key="index"
                >
                  {{ item.price | formatMoney }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数量（支）" width="auto" align="center">
            <template slot-scope="scope">
              <span class="top-bg" />
              <div class="order-details">
                <div
                  :class="
                    scope.row.goodsList.length > 1
                      ? 'set-height bor-bottom bor-right'
                      : 'box'
                  "
                  v-for="(item, index) in scope.row.goodsList"
                  :key="index"
                >
                  {{ item.num }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="订单归属商家" width="auto" align="center">
            <template slot-scope="scope">
              <span class="top-bg" />
              <div class="order-details">
                {{ scope.row.appletsName }}
                <el-input
                  v-if="scope.row.salesName"
                  style="width: 110px;"
                  v-model="scope.row.salesName"
                  disabled
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="订单金额" width="auto" align="center">
            <template slot-scope="scope">
              <span class="top-bg">
                <div class="order-time">
                  下单时间：{{ scope.row.orderTime }}
                </div>
              </span>
              <div class="order-details">
                <p class="money">
                  {{ scope.row.orderAmount | formatMoney }}
                </p>
                <p>运费：{{ scope.row.shipping }}</p>
                <p>
                  <i class="iconfont icon-weixin"></i>
                  {{ scope.row.paymentType }}
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="买家账号" width="auto" align="center">
            <template slot-scope="scope">
              <span class="top-bg" />
              <div class="order-details ellipses">
                {{ scope.row.account }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="订单来源" width="auto" align="center">
            <template slot-scope="scope">
              <span class="top-bg">
                <div class="order-time">
                  付款时间：{{ scope.row.paymentTime }}
                </div>
              </span>
              <div
                class="order-details"
                v-orderSource="{
                  source: scope.row.orderSource,
                  state: scope.row.orderType
                }"
              />
            </template>
          </el-table-column>
          <el-table-column label="订单状态" width="auto" align="center">
            <template slot-scope="scope">
              <span class="top-bg" />
              <div class="order-details" style="display: inline-block">
                {{ scope.row.orderState | formatOrderStatus }}
              </div>

              <fragment v-if="+scope.row.refundType > 0">
                /
                {{ scope.row.refundType | formatOrderStatus }}
                /
                {{ scope.row.refundState | formatRefundStatus }}
              </fragment>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination
        v-if="pagination.recordTotal > 1"
        :currentPage="pagination.currentPage"
        :totalPage="pagination.pageTotal"
        :totalRecord="pagination.recordTotal"
        @handleNextPage="nextPage"
        @handlePrevPage="prevPage"
        @handleJumpPage="jumpPage"
        @handleChangePageSize="changePageSize"
      />
    </div>
  </div>
</template>
<script>
import pagination from 'mixins/pagination/'

export default {
  name: 'orderInfo',
  mixins: [pagination],
  data() {
    this.keyMap = {
      order_list: {
        name: 'tableData',
        add_time: 'orderTime',
        app_name: 'appletsName',
        goods_list: 'goodsList',
        goods_en: 'enName',
        goods_id: 'goodsId',
        goods_image: 'imgUrl',
        goods_price: 'price',
        goods_name: 'cnName',
        goods_sku: 'sku',
        goods_num: 'num',
        member_name: 'account',
        order_amount: 'orderAmount',
        order_id: 'orderId',
        pay_sn: 'paySn',
        order_message: 'info',
        order_source: 'orderSource',
        order_state: 'orderState',
        order_type: 'orderType',
        payment_code: 'paymentType',
        payment_time: 'paymentTime',
        sales_name: 'salesName',
        shipping_fee: 'shipping',
        refund_id: 'refundId',
        refund_state: 'refundState',
        refund_type: 'refundType'
      }
    }
    this.type = 'pagination'
    return {
      month: '',
      tableData: [],
      pagination: {}
    }
  },
  created() {
    this._clerkOrder({
      curpage: 1,
      sales_id: this.$route.query.id
    })
  },
  methods: {
    /**
     * 获取关联订单
     * @param params
     */
    _clerkOrder(params) {
      this.api.clerkOrder(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    },
    /**
     * 翻页
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      this._clerkOrder({
        curpage: newValue,
        sales_id: this.$route.query.id,
        pageSize: size
      })
    },

    /**
     * 按月筛选
     */
    filterMonth() {
      this.year = ''
      const m = this.month.split('-')
      this._clerkOrder({
        sales_id: this.$route.query.id,
        year: m[0],
        month: m[1],
        search_mode: 'month'
      })
    }
  }
}
</script>
<style lang="scss">
.order-info {
  background-color: #fff;

  .export {
    float: right;
    width: 6.3rem;
    height: 2rem;
    padding: 0;
    margin-right: 2.3rem;
  }

  .select {
    width: 9.3rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: 1rem;
    border: solid 1px #34313a;

    &:nth-child(2) {
      margin-left: 2rem;
    }

    .el-input,
    .el-input__icon,
    .el-input__suffix-inner {
      height: 100%;
      line-height: 100%;
      color: #010101 !important;
    }

    input {
      background-color: transparent;
      height: 100%;
    }

    ::placeholder {
      color: #010101;
    }
  }
}
</style>
